/**
 * Tailwind screen breakpoints in pixels. These mirror the values in
 * src/global.css @theme so that JS logic can stay in sync with CSS classes.
 */
export const breakpoints = {
  sm: 640,
  md: 768,
  menuLg: 872,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
} as const;
